"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _Typography = _interopRequireDefault(require("../Typography"));

var _theme = require("../theme");

var _constants = require("../theme/constants");

var _core = require("@emotion/core");

function Text(_ref) {
  var _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'span' : _ref$as,
      bold = _ref.bold,
      children = _ref.children,
      color = _ref.color,
      id = _ref.id,
      textAlign = _ref.textAlign,
      _ref$typography = _ref.typography,
      typography = _ref$typography === void 0 ? _constants.TYPOGRAPHY.LARGE_BODY : _ref$typography,
      textTransform = _ref.textTransform,
      props = (0, _objectWithoutProperties2.default)(_ref, ["as", "bold", "children", "color", "id", "textAlign", "typography", "textTransform"]);

  var _useTheme = (0, _theme.useTheme)(),
      themeStyles = _useTheme.typography;

  var _themeStyles$typograp = themeStyles[typography],
      fontFamily = _themeStyles$typograp.fontFamily,
      fontSize = _themeStyles$typograp.fontSize,
      fontWeight = _themeStyles$typograp.fontWeight,
      letterSpacing = _themeStyles$typograp.letterSpacing,
      lineHeight = _themeStyles$typograp.lineHeight;
  return (0, _core.jsx)(_Typography.default // this is here for accessibility properties, this will allow us to pass things like
  // aria-hidden, role, etc without having to explicitly call them out in the type definitions
  , (0, _extends2.default)({}, props, {
    // strong has semantic meaning, simply setting text to bold with css, isn't conveyed to screenreaders
    as: bold ? 'strong' : as,
    color: color,
    fontFamily: fontFamily,
    fontSize: fontSize,
    fontWeight: bold ? _constants.FONT_WEIGHT.BOLD : fontWeight,
    id: id,
    letterSpacing: letterSpacing,
    lineHeight: lineHeight,
    textAlign: textAlign,
    textTransform: textTransform
  }), children);
}

var _default = Text;
exports.default = _default;